export default __webpack_public_path__ + "static/media/detail_mobile_2_5.74ed4b54.png";